import { Dispatch, SetStateAction } from 'react';

import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

import { PasswordChangeApiInputs } from '@type/mypage';

import {
  UPDATE_ERROR_MESSAGE,
  UPDATE_SUCCESS_MESSAGE,
} from '@constants/toastMessage';

import { update } from '@apis/api';

/** 비밀번호 변경하기 */
export function usePasswordChange(
  setConfirmModalOpen: Dispatch<SetStateAction<boolean>>,
  reset: any
) {
  const { mutate, isLoading } = useMutation(
    ['password-change'],
    (value: PasswordChangeApiInputs) =>
      update('/login-account/password', value),
    {
      onSuccess: (res: any) => {
        if (res?.isError) {
          toast.error(UPDATE_ERROR_MESSAGE);
          console.log(`ERROR[${res?.data?.errorCode}] : ${res?.data?.message}`);
          setConfirmModalOpen(false);
        } else {
          toast.success(UPDATE_SUCCESS_MESSAGE);
          reset();
          setConfirmModalOpen(false);
        }
      },
    }
  );

  return {
    mutate,
    isLoading,
  };
}
